"use strict";
var equal = require("ajv/lib/compile/equal");
var validate = (function () {
  var refVal = [];
  var refVal1 = (function () {
    return function validate(
      data,
      dataPath,
      parentData,
      parentDataProperty,
      rootData
    ) {
      "use strict";
      var vErrors = null;
      var errors = 0;
      if (rootData === undefined) rootData = data;
      if (data && typeof data === "object" && !Array.isArray(data)) {
        if (data.full_width === undefined) data.full_width = false;
        if (true) {
          var errs__0 = errors;
          var valid1 = true;
          if (data.background === undefined) {
            valid1 = true;
          } else {
            var errs_1 = errors;
            if (typeof data.background !== "string") {
              validate.errors = [
                {
                  keyword: "type",
                  dataPath: (dataPath || "") + ".background",
                  schemaPath: "#/properties/background/type",
                  params: {
                    type: "string"
                  },
                  message: "should be string"
                }
              ];
              return false;
            }
            var valid1 = errors === errs_1;
          }
          if (valid1) {
            if (data.background_image === undefined) {
              valid1 = true;
            } else {
              var errs_1 = errors;
              if (typeof data.background_image !== "string") {
                validate.errors = [
                  {
                    keyword: "type",
                    dataPath: (dataPath || "") + ".background_image",
                    schemaPath: "#/properties/background_image/type",
                    params: {
                      type: "string"
                    },
                    message: "should be string"
                  }
                ];
                return false;
              }
              var valid1 = errors === errs_1;
            }
            if (valid1) {
              if (data.background_position === undefined) {
                valid1 = true;
              } else {
                var errs_1 = errors;
                if (typeof data.background_position !== "string") {
                  validate.errors = [
                    {
                      keyword: "type",
                      dataPath: (dataPath || "") + ".background_position",
                      schemaPath: "#/properties/background_position/type",
                      params: {
                        type: "string"
                      },
                      message: "should be string"
                    }
                  ];
                  return false;
                }
                var valid1 = errors === errs_1;
              }
              if (valid1) {
                if (data.background_repeat === undefined) {
                  valid1 = true;
                } else {
                  var errs_1 = errors;
                  if (typeof data.background_repeat !== "string") {
                    validate.errors = [
                      {
                        keyword: "type",
                        dataPath: (dataPath || "") + ".background_repeat",
                        schemaPath: "#/properties/background_repeat/type",
                        params: {
                          type: "string"
                        },
                        message: "should be string"
                      }
                    ];
                    return false;
                  }
                  var valid1 = errors === errs_1;
                }
                if (valid1) {
                  var errs_1 = errors;
                  if (typeof data.full_width !== "boolean") {
                    validate.errors = [
                      {
                        keyword: "type",
                        dataPath: (dataPath || "") + ".full_width",
                        schemaPath: "#/properties/full_width/type",
                        params: {
                          type: "boolean"
                        },
                        message: "should be boolean"
                      }
                    ];
                    return false;
                  }
                  var valid1 = errors === errs_1;
                  if (valid1) {
                    if (valid1) {
                      var data1 = data.contents;
                      if (data1 === undefined) {
                        valid1 = false;
                        validate.errors = [
                          {
                            keyword: "required",
                            dataPath: (dataPath || "") + "",
                            schemaPath: "#/required",
                            params: {
                              missingProperty: "contents"
                            },
                            message: "should have required property 'contents'"
                          }
                        ];
                        return false;
                      } else {
                        var errs_1 = errors;
                        var errs__1 = errors;
                        var valid1 = false;
                        var errs_2 = errors;
                        if (Array.isArray(data1)) {
                          var errs__2 = errors;
                          var valid2;
                          for (var i2 = 0; i2 < data1.length; i2++) {
                            var errs_3 = errors;
                            if (
                              !refVal2(
                                data1[i2],
                                (dataPath || "") + ".contents[" + i2 + "]",
                                data1,
                                i2,
                                rootData
                              )
                            ) {
                              if (vErrors === null) vErrors = refVal2.errors;
                              else vErrors = vErrors.concat(refVal2.errors);
                              errors = vErrors.length;
                            }
                            var valid3 = errors === errs_3;
                            if (!valid3) break;
                          }
                        } else {
                          var err = {
                            keyword: "type",
                            dataPath: (dataPath || "") + ".contents",
                            schemaPath: "#/properties/contents/anyOf/0/type",
                            params: {
                              type: "array"
                            },
                            message: "should be array"
                          };
                          if (vErrors === null) vErrors = [err];
                          else vErrors.push(err);
                          errors++;
                        }
                        var valid2 = errors === errs_2;
                        valid1 = valid1 || valid2;
                        if (!valid1) {
                          var errs_2 = errors;
                          if (data1 !== null) {
                            var err = {
                              keyword: "type",
                              dataPath: (dataPath || "") + ".contents",
                              schemaPath: "#/properties/contents/anyOf/1/type",
                              params: {
                                type: "null"
                              },
                              message: "should be null"
                            };
                            if (vErrors === null) vErrors = [err];
                            else vErrors.push(err);
                            errors++;
                          }
                          var valid2 = errors === errs_2;
                          valid1 = valid1 || valid2;
                        }
                        if (!valid1) {
                          var err = {
                            keyword: "anyOf",
                            dataPath: (dataPath || "") + ".contents",
                            schemaPath: "#/properties/contents/anyOf",
                            params: {},
                            message: "should match some schema in anyOf"
                          };
                          if (vErrors === null) vErrors = [err];
                          else vErrors.push(err);
                          errors++;
                          validate.errors = vErrors;
                          return false;
                        } else {
                          errors = errs__1;
                          if (vErrors !== null) {
                            if (errs__1) vErrors.length = errs__1;
                            else vErrors = null;
                          }
                        }
                        var valid1 = errors === errs_1;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      } else {
        validate.errors = [
          {
            keyword: "type",
            dataPath: (dataPath || "") + "",
            schemaPath: "#/type",
            params: {
              type: "object"
            },
            message: "should be object"
          }
        ];
        return false;
      }
      validate.errors = vErrors;
      return errors === 0;
    };
  })();
  refVal1.schema = {
    type: "object",
    properties: {
      background: {
        type: "string"
      },
      background_image: {
        type: "string"
      },
      background_position: {
        type: "string"
      },
      background_repeat: {
        type: "string"
      },
      full_width: {
        type: "boolean",
        default: false
      },
      contents: {
        anyOf: [
          {
            type: "array",
            items: {
              $ref: "#/definitions/content"
            }
          },
          {
            type: "null"
          }
        ]
      }
    },
    required: ["contents"]
  };
  refVal1.errors = null;
  refVal[1] = refVal1;
  var refVal2 = (function () {
    return function validate(
      data,
      dataPath,
      parentData,
      parentDataProperty,
      rootData
    ) {
      "use strict";
      var vErrors = null;
      var errors = 0;
      if (rootData === undefined) rootData = data;
      if (data && typeof data === "object" && !Array.isArray(data)) {
        if (true) {
          var errs__0 = errors;
          var valid1 = true;
          var data1 = data.column;
          if (data1 === undefined) {
            valid1 = false;
            validate.errors = [
              {
                keyword: "required",
                dataPath: (dataPath || "") + "",
                schemaPath: "#/required",
                params: {
                  missingProperty: "column"
                },
                message: "should have required property 'column'"
              }
            ];
            return false;
          } else {
            var errs_1 = errors;
            if (typeof data1 !== "string") {
              validate.errors = [
                {
                  keyword: "type",
                  dataPath: (dataPath || "") + ".column",
                  schemaPath: "#/properties/column/type",
                  params: {
                    type: "string"
                  },
                  message: "should be string"
                }
              ];
              return false;
            }
            var schema1 = validate.schema.properties.column.enum;
            var valid1;
            valid1 = false;
            for (var i1 = 0; i1 < schema1.length; i1++)
              if (equal(data1, schema1[i1])) {
                valid1 = true;
                break;
              }
            if (!valid1) {
              validate.errors = [
                {
                  keyword: "enum",
                  dataPath: (dataPath || "") + ".column",
                  schemaPath: "#/properties/column/enum",
                  params: {
                    allowedValues: schema1
                  },
                  message: "should be equal to one of the allowed values"
                }
              ];
              return false;
            }
            var valid1 = errors === errs_1;
          }
          if (valid1) {
            var data1 = data.items;
            if (data1 === undefined) {
              valid1 = false;
              validate.errors = [
                {
                  keyword: "required",
                  dataPath: (dataPath || "") + "",
                  schemaPath: "#/required",
                  params: {
                    missingProperty: "items"
                  },
                  message: "should have required property 'items'"
                }
              ];
              return false;
            } else {
              var errs_1 = errors;
              var errs__1 = errors;
              var valid1 = false;
              var errs_2 = errors;
              if (Array.isArray(data1)) {
                var errs__2 = errors;
                var valid2;
                for (var i2 = 0; i2 < data1.length; i2++) {
                  var errs_3 = errors;
                  if (
                    !refVal3(
                      data1[i2],
                      (dataPath || "") + ".items[" + i2 + "]",
                      data1,
                      i2,
                      rootData
                    )
                  ) {
                    if (vErrors === null) vErrors = refVal3.errors;
                    else vErrors = vErrors.concat(refVal3.errors);
                    errors = vErrors.length;
                  }
                  var valid3 = errors === errs_3;
                  if (!valid3) break;
                }
              } else {
                var err = {
                  keyword: "type",
                  dataPath: (dataPath || "") + ".items",
                  schemaPath: "#/properties/items/anyOf/0/type",
                  params: {
                    type: "array"
                  },
                  message: "should be array"
                };
                if (vErrors === null) vErrors = [err];
                else vErrors.push(err);
                errors++;
              }
              var valid2 = errors === errs_2;
              valid1 = valid1 || valid2;
              if (!valid1) {
                var errs_2 = errors;
                if (data1 !== null) {
                  var err = {
                    keyword: "type",
                    dataPath: (dataPath || "") + ".items",
                    schemaPath: "#/properties/items/anyOf/1/type",
                    params: {
                      type: "null"
                    },
                    message: "should be null"
                  };
                  if (vErrors === null) vErrors = [err];
                  else vErrors.push(err);
                  errors++;
                }
                var valid2 = errors === errs_2;
                valid1 = valid1 || valid2;
              }
              if (!valid1) {
                var err = {
                  keyword: "anyOf",
                  dataPath: (dataPath || "") + ".items",
                  schemaPath: "#/properties/items/anyOf",
                  params: {},
                  message: "should match some schema in anyOf"
                };
                if (vErrors === null) vErrors = [err];
                else vErrors.push(err);
                errors++;
                validate.errors = vErrors;
                return false;
              } else {
                errors = errs__1;
                if (vErrors !== null) {
                  if (errs__1) vErrors.length = errs__1;
                  else vErrors = null;
                }
              }
              var valid1 = errors === errs_1;
            }
          }
        }
      } else {
        validate.errors = [
          {
            keyword: "type",
            dataPath: (dataPath || "") + "",
            schemaPath: "#/type",
            params: {
              type: "object"
            },
            message: "should be object"
          }
        ];
        return false;
      }
      validate.errors = vErrors;
      return errors === 0;
    };
  })();
  refVal2.schema = {
    type: "object",
    properties: {
      column: {
        type: "string",
        enum: [
          "one",
          "two",
          "three",
          "four",
          "five",
          "six",
          "seven",
          "eight",
          "nine",
          "ten",
          "eleven",
          "twelve"
        ]
      },
      items: {
        anyOf: [
          {
            type: "array",
            items: {
              $ref: "#/definitions/item"
            }
          },
          {
            type: "null"
          }
        ]
      }
    },
    required: ["column", "items"]
  };
  refVal2.errors = null;
  refVal[2] = refVal2;
  var refVal3 = (function () {
    return function validate(
      data,
      dataPath,
      parentData,
      parentDataProperty,
      rootData
    ) {
      "use strict";
      var vErrors = null;
      var errors = 0;
      if (rootData === undefined) rootData = data;
      if (data && typeof data === "object" && !Array.isArray(data)) {
        var missing0;
        if (data.kind === undefined && (missing0 = ".kind")) {
          validate.errors = [
            {
              keyword: "required",
              dataPath: (dataPath || "") + "",
              schemaPath: "#/required",
              params: {
                missingProperty: "" + missing0 + ""
              },
              message: "should have required property '" + missing0 + "'"
            }
          ];
          return false;
        } else {
          var errs__0 = errors;
          var valid1 = true;
          if (data.alt === undefined) {
            valid1 = true;
          } else {
            var errs_1 = errors;
            if (typeof data.alt !== "string") {
              validate.errors = [
                {
                  keyword: "type",
                  dataPath: (dataPath || "") + ".alt",
                  schemaPath: "#/properties/alt/type",
                  params: {
                    type: "string"
                  },
                  message: "should be string"
                }
              ];
              return false;
            }
            var valid1 = errors === errs_1;
          }
          if (valid1) {
            if (data.font_family === undefined) {
              valid1 = true;
            } else {
              var errs_1 = errors;
              if (typeof data.font_family !== "string") {
                validate.errors = [
                  {
                    keyword: "type",
                    dataPath: (dataPath || "") + ".font_family",
                    schemaPath: "#/properties/font_family/type",
                    params: {
                      type: "string"
                    },
                    message: "should be string"
                  }
                ];
                return false;
              }
              var valid1 = errors === errs_1;
            }
            if (valid1) {
              if (data.font_size === undefined) {
                valid1 = true;
              } else {
                var errs_1 = errors;
                if (typeof data.font_size !== "string") {
                  validate.errors = [
                    {
                      keyword: "type",
                      dataPath: (dataPath || "") + ".font_size",
                      schemaPath: "#/properties/font_size/type",
                      params: {
                        type: "string"
                      },
                      message: "should be string"
                    }
                  ];
                  return false;
                }
                var valid1 = errors === errs_1;
              }
              if (valid1) {
                if (data.css_background === undefined) {
                  valid1 = true;
                } else {
                  var errs_1 = errors;
                  if (typeof data.css_background !== "string") {
                    validate.errors = [
                      {
                        keyword: "type",
                        dataPath: (dataPath || "") + ".css_background",
                        schemaPath: "#/properties/css_background/type",
                        params: {
                          type: "string"
                        },
                        message: "should be string"
                      }
                    ];
                    return false;
                  }
                  var valid1 = errors === errs_1;
                }
                if (valid1) {
                  if (data.css_background_image === undefined) {
                    valid1 = true;
                  } else {
                    var errs_1 = errors;
                    if (typeof data.css_background_image !== "string") {
                      validate.errors = [
                        {
                          keyword: "type",
                          dataPath: (dataPath || "") + ".css_background_image",
                          schemaPath: "#/properties/css_background_image/type",
                          params: {
                            type: "string"
                          },
                          message: "should be string"
                        }
                      ];
                      return false;
                    }
                    var valid1 = errors === errs_1;
                  }
                  if (valid1) {
                    if (data.css_background_position === undefined) {
                      valid1 = true;
                    } else {
                      var errs_1 = errors;
                      if (typeof data.css_background_position !== "string") {
                        validate.errors = [
                          {
                            keyword: "type",
                            dataPath:
                              (dataPath || "") + ".css_background_position",
                            schemaPath:
                              "#/properties/css_background_position/type",
                            params: {
                              type: "string"
                            },
                            message: "should be string"
                          }
                        ];
                        return false;
                      }
                      var valid1 = errors === errs_1;
                    }
                    if (valid1) {
                      if (data.css_background_repeat === undefined) {
                        valid1 = true;
                      } else {
                        var errs_1 = errors;
                        if (typeof data.css_background_repeat !== "string") {
                          validate.errors = [
                            {
                              keyword: "type",
                              dataPath:
                                (dataPath || "") + ".css_background_repeat",
                              schemaPath:
                                "#/properties/css_background_repeat/type",
                              params: {
                                type: "string"
                              },
                              message: "should be string"
                            }
                          ];
                          return false;
                        }
                        var valid1 = errors === errs_1;
                      }
                      if (valid1) {
                        if (data.css_class === undefined) {
                          valid1 = true;
                        } else {
                          var errs_1 = errors;
                          if (typeof data.css_class !== "string") {
                            validate.errors = [
                              {
                                keyword: "type",
                                dataPath: (dataPath || "") + ".css_class",
                                schemaPath: "#/properties/css_class/type",
                                params: {
                                  type: "string"
                                },
                                message: "should be string"
                              }
                            ];
                            return false;
                          }
                          var valid1 = errors === errs_1;
                        }
                        if (valid1) {
                          if (data.css_color === undefined) {
                            valid1 = true;
                          } else {
                            var errs_1 = errors;
                            if (typeof data.css_color !== "string") {
                              validate.errors = [
                                {
                                  keyword: "type",
                                  dataPath: (dataPath || "") + ".css_color",
                                  schemaPath: "#/properties/css_color/type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "should be string"
                                }
                              ];
                              return false;
                            }
                            var valid1 = errors === errs_1;
                          }
                          if (valid1) {
                            if (data.css_link_color === undefined) {
                              valid1 = true;
                            } else {
                              var errs_1 = errors;
                              if (typeof data.css_link_color !== "string") {
                                validate.errors = [
                                  {
                                    keyword: "type",
                                    dataPath:
                                      (dataPath || "") + ".css_link_color",
                                    schemaPath:
                                      "#/properties/css_link_color/type",
                                    params: {
                                      type: "string"
                                    },
                                    message: "should be string"
                                  }
                                ];
                                return false;
                              }
                              var valid1 = errors === errs_1;
                            }
                            if (valid1) {
                              if (data.css_border === undefined) {
                                valid1 = true;
                              } else {
                                var errs_1 = errors;
                                if (typeof data.css_border !== "string") {
                                  validate.errors = [
                                    {
                                      keyword: "type",
                                      dataPath:
                                        (dataPath || "") + ".css_border",
                                      schemaPath:
                                        "#/properties/css_border/type",
                                      params: {
                                        type: "string"
                                      },
                                      message: "should be string"
                                    }
                                  ];
                                  return false;
                                }
                                var valid1 = errors === errs_1;
                              }
                              if (valid1) {
                                if (data.css_size === undefined) {
                                  valid1 = true;
                                } else {
                                  var errs_1 = errors;
                                  if (typeof data.css_size !== "string") {
                                    validate.errors = [
                                      {
                                        keyword: "type",
                                        dataPath:
                                          (dataPath || "") + ".css_size",
                                        schemaPath:
                                          "#/properties/css_size/type",
                                        params: {
                                          type: "string"
                                        },
                                        message: "should be string"
                                      }
                                    ];
                                    return false;
                                  }
                                  var valid1 = errors === errs_1;
                                }
                                if (valid1) {
                                  if (data.css_border_radius === undefined) {
                                    valid1 = true;
                                  } else {
                                    var errs_1 = errors;
                                    if (
                                      typeof data.css_border_radius !== "string"
                                    ) {
                                      validate.errors = [
                                        {
                                          keyword: "type",
                                          dataPath:
                                            (dataPath || "") +
                                            ".css_border_radius",
                                          schemaPath:
                                            "#/properties/css_border_radius/type",
                                          params: {
                                            type: "string"
                                          },
                                          message: "should be string"
                                        }
                                      ];
                                      return false;
                                    }
                                    var valid1 = errors === errs_1;
                                  }
                                  if (valid1) {
                                    if (data.css_border_color === undefined) {
                                      valid1 = true;
                                    } else {
                                      var errs_1 = errors;
                                      if (
                                        typeof data.css_border_color !==
                                        "string"
                                      ) {
                                        validate.errors = [
                                          {
                                            keyword: "type",
                                            dataPath:
                                              (dataPath || "") +
                                              ".css_border_color",
                                            schemaPath:
                                              "#/properties/css_border_color/type",
                                            params: {
                                              type: "string"
                                            },
                                            message: "should be string"
                                          }
                                        ];
                                        return false;
                                      }
                                      var valid1 = errors === errs_1;
                                    }
                                    if (valid1) {
                                      if (data.css_padding_top === undefined) {
                                        valid1 = true;
                                      } else {
                                        var errs_1 = errors;
                                        if (
                                          typeof data.css_padding_top !==
                                          "string"
                                        ) {
                                          validate.errors = [
                                            {
                                              keyword: "type",
                                              dataPath:
                                                (dataPath || "") +
                                                ".css_padding_top",
                                              schemaPath:
                                                "#/properties/css_padding_top/type",
                                              params: {
                                                type: "string"
                                              },
                                              message: "should be string"
                                            }
                                          ];
                                          return false;
                                        }
                                        var valid1 = errors === errs_1;
                                      }
                                      if (valid1) {
                                        if (
                                          data.css_padding_bottom === undefined
                                        ) {
                                          valid1 = true;
                                        } else {
                                          var errs_1 = errors;
                                          if (
                                            typeof data.css_padding_bottom !==
                                            "string"
                                          ) {
                                            validate.errors = [
                                              {
                                                keyword: "type",
                                                dataPath:
                                                  (dataPath || "") +
                                                  ".css_padding_bottom",
                                                schemaPath:
                                                  "#/properties/css_padding_bottom/type",
                                                params: {
                                                  type: "string"
                                                },
                                                message: "should be string"
                                              }
                                            ];
                                            return false;
                                          }
                                          var valid1 = errors === errs_1;
                                        }
                                        if (valid1) {
                                          if (
                                            data.css_padding_left === undefined
                                          ) {
                                            valid1 = true;
                                          } else {
                                            var errs_1 = errors;
                                            if (
                                              typeof data.css_padding_left !==
                                              "string"
                                            ) {
                                              validate.errors = [
                                                {
                                                  keyword: "type",
                                                  dataPath:
                                                    (dataPath || "") +
                                                    ".css_padding_left",
                                                  schemaPath:
                                                    "#/properties/css_padding_left/type",
                                                  params: {
                                                    type: "string"
                                                  },
                                                  message: "should be string"
                                                }
                                              ];
                                              return false;
                                            }
                                            var valid1 = errors === errs_1;
                                          }
                                          if (valid1) {
                                            if (
                                              data.css_padding_right ===
                                              undefined
                                            ) {
                                              valid1 = true;
                                            } else {
                                              var errs_1 = errors;
                                              if (
                                                typeof data.css_padding_right !==
                                                "string"
                                              ) {
                                                validate.errors = [
                                                  {
                                                    keyword: "type",
                                                    dataPath:
                                                      (dataPath || "") +
                                                      ".css_padding_right",
                                                    schemaPath:
                                                      "#/properties/css_padding_right/type",
                                                    params: {
                                                      type: "string"
                                                    },
                                                    message: "should be string"
                                                  }
                                                ];
                                                return false;
                                              }
                                              var valid1 = errors === errs_1;
                                            }
                                            if (valid1) {
                                              if (
                                                data.css_padding_lock ===
                                                undefined
                                              ) {
                                                valid1 = true;
                                              } else {
                                                var errs_1 = errors;
                                                if (
                                                  typeof data.css_padding_lock !==
                                                  "boolean"
                                                ) {
                                                  validate.errors = [
                                                    {
                                                      keyword: "type",
                                                      dataPath:
                                                        (dataPath || "") +
                                                        ".css_padding_lock",
                                                      schemaPath:
                                                        "#/properties/css_padding_lock/type",
                                                      params: {
                                                        type: "boolean"
                                                      },
                                                      message:
                                                        "should be boolean"
                                                    }
                                                  ];
                                                  return false;
                                                }
                                                var valid1 = errors === errs_1;
                                              }
                                              if (valid1) {
                                                if (data.label === undefined) {
                                                  valid1 = true;
                                                } else {
                                                  var errs_1 = errors;
                                                  if (
                                                    typeof data.label !==
                                                    "string"
                                                  ) {
                                                    validate.errors = [
                                                      {
                                                        keyword: "type",
                                                        dataPath:
                                                          (dataPath || "") +
                                                          ".label",
                                                        schemaPath:
                                                          "#/properties/label/type",
                                                        params: {
                                                          type: "string"
                                                        },
                                                        message:
                                                          "should be string"
                                                      }
                                                    ];
                                                    return false;
                                                  }
                                                  var valid1 =
                                                    errors === errs_1;
                                                }
                                                if (valid1) {
                                                  if (data.id === undefined) {
                                                    valid1 = false;
                                                    validate.errors = [
                                                      {
                                                        keyword: "required",
                                                        dataPath:
                                                          (dataPath || "") + "",
                                                        schemaPath:
                                                          "#/required",
                                                        params: {
                                                          missingProperty: "id"
                                                        },
                                                        message:
                                                          "should have required property 'id'"
                                                      }
                                                    ];
                                                    return false;
                                                  } else {
                                                    var errs_1 = errors;
                                                    if (
                                                      typeof data.id !==
                                                      "string"
                                                    ) {
                                                      validate.errors = [
                                                        {
                                                          keyword: "type",
                                                          dataPath:
                                                            (dataPath || "") +
                                                            ".id",
                                                          schemaPath:
                                                            "#/properties/id/type",
                                                          params: {
                                                            type: "string"
                                                          },
                                                          message:
                                                            "should be string"
                                                        }
                                                      ];
                                                      return false;
                                                    }
                                                    var valid1 =
                                                      errors === errs_1;
                                                  }
                                                  if (valid1) {
                                                    if (
                                                      data.normal_size ===
                                                      undefined
                                                    ) {
                                                      valid1 = true;
                                                    } else {
                                                      var errs_1 = errors;
                                                      if (
                                                        typeof data.normal_size !==
                                                        "boolean"
                                                      ) {
                                                        validate.errors = [
                                                          {
                                                            keyword: "type",
                                                            dataPath:
                                                              (dataPath || "") +
                                                              ".normal_size",
                                                            schemaPath:
                                                              "#/properties/normal_size/type",
                                                            params: {
                                                              type: "boolean"
                                                            },
                                                            message:
                                                              "should be boolean"
                                                          }
                                                        ];
                                                        return false;
                                                      }
                                                      var valid1 =
                                                        errors === errs_1;
                                                    }
                                                    if (valid1) {
                                                      if (
                                                        data.show_sm ===
                                                        undefined
                                                      ) {
                                                        valid1 = true;
                                                      } else {
                                                        var errs_1 = errors;
                                                        if (
                                                          typeof data.show_sm !==
                                                          "boolean"
                                                        ) {
                                                          validate.errors = [
                                                            {
                                                              keyword: "type",
                                                              dataPath:
                                                                (dataPath ||
                                                                  "") +
                                                                ".show_sm",
                                                              schemaPath:
                                                                "#/properties/show_sm/type",
                                                              params: {
                                                                type: "boolean"
                                                              },
                                                              message:
                                                                "should be boolean"
                                                            }
                                                          ];
                                                          return false;
                                                        }
                                                        var valid1 =
                                                          errors === errs_1;
                                                      }
                                                      if (valid1) {
                                                        if (
                                                          data.hide_sm ===
                                                          undefined
                                                        ) {
                                                          valid1 = true;
                                                        } else {
                                                          var errs_1 = errors;
                                                          if (
                                                            typeof data.hide_sm !==
                                                            "boolean"
                                                          ) {
                                                            validate.errors = [
                                                              {
                                                                keyword: "type",
                                                                dataPath:
                                                                  (dataPath ||
                                                                    "") +
                                                                  ".hide_sm",
                                                                schemaPath:
                                                                  "#/properties/hide_sm/type",
                                                                params: {
                                                                  type:
                                                                    "boolean"
                                                                },
                                                                message:
                                                                  "should be boolean"
                                                              }
                                                            ];
                                                            return false;
                                                          }
                                                          var valid1 =
                                                            errors === errs_1;
                                                        }
                                                        if (valid1) {
                                                          if (
                                                            data.contents ===
                                                            undefined
                                                          ) {
                                                            valid1 = true;
                                                          } else {
                                                            var errs_1 = errors;
                                                            if (
                                                              typeof data.contents !==
                                                              "string"
                                                            ) {
                                                              validate.errors = [
                                                                {
                                                                  keyword:
                                                                    "type",
                                                                  dataPath:
                                                                    (dataPath ||
                                                                      "") +
                                                                    ".contents",
                                                                  schemaPath:
                                                                    "#/properties/contents/type",
                                                                  params: {
                                                                    type:
                                                                      "string"
                                                                  },
                                                                  message:
                                                                    "should be string"
                                                                }
                                                              ];
                                                              return false;
                                                            }
                                                            var valid1 =
                                                              errors === errs_1;
                                                          }
                                                          if (valid1) {
                                                            if (
                                                              data.size ===
                                                              undefined
                                                            ) {
                                                              valid1 = true;
                                                            } else {
                                                              var errs_1 = errors;
                                                              if (
                                                                typeof data.size !==
                                                                "string"
                                                              ) {
                                                                validate.errors = [
                                                                  {
                                                                    keyword:
                                                                      "type",
                                                                    dataPath:
                                                                      (dataPath ||
                                                                        "") +
                                                                      ".size",
                                                                    schemaPath:
                                                                      "#/properties/size/type",
                                                                    params: {
                                                                      type:
                                                                        "string"
                                                                    },
                                                                    message:
                                                                      "should be string"
                                                                  }
                                                                ];
                                                                return false;
                                                              }
                                                              var valid1 =
                                                                errors ===
                                                                errs_1;
                                                            }
                                                            if (valid1) {
                                                              if (
                                                                data.height ===
                                                                undefined
                                                              ) {
                                                                valid1 = true;
                                                              } else {
                                                                var errs_1 = errors;
                                                                if (
                                                                  typeof data.height !==
                                                                  "string"
                                                                ) {
                                                                  validate.errors = [
                                                                    {
                                                                      keyword:
                                                                        "type",
                                                                      dataPath:
                                                                        (dataPath ||
                                                                          "") +
                                                                        ".height",
                                                                      schemaPath:
                                                                        "#/properties/height/type",
                                                                      params: {
                                                                        type:
                                                                          "string"
                                                                      },
                                                                      message:
                                                                        "should be string"
                                                                    }
                                                                  ];
                                                                  return false;
                                                                }
                                                                var valid1 =
                                                                  errors ===
                                                                  errs_1;
                                                              }
                                                              if (valid1) {
                                                                var data1 =
                                                                  data.natural_width;
                                                                if (
                                                                  data1 ===
                                                                  undefined
                                                                ) {
                                                                  valid1 = true;
                                                                } else {
                                                                  var errs_1 = errors;
                                                                  var errs__1 = errors;
                                                                  var valid1 = false;
                                                                  var errs_2 = errors;
                                                                  if (
                                                                    typeof data1 !==
                                                                    "string"
                                                                  ) {
                                                                    var err = {
                                                                      keyword:
                                                                        "type",
                                                                      dataPath:
                                                                        (dataPath ||
                                                                          "") +
                                                                        ".natural_width",
                                                                      schemaPath:
                                                                        "#/properties/natural_width/anyOf/0/type",
                                                                      params: {
                                                                        type:
                                                                          "string"
                                                                      },
                                                                      message:
                                                                        "should be string"
                                                                    };
                                                                    if (
                                                                      vErrors ===
                                                                      null
                                                                    )
                                                                      vErrors = [
                                                                        err
                                                                      ];
                                                                    else
                                                                      vErrors.push(
                                                                        err
                                                                      );
                                                                    errors++;
                                                                  }
                                                                  var valid2 =
                                                                    errors ===
                                                                    errs_2;
                                                                  valid1 =
                                                                    valid1 ||
                                                                    valid2;
                                                                  if (!valid1) {
                                                                    var errs_2 = errors;
                                                                    if (
                                                                      typeof data1 !==
                                                                      "number"
                                                                    ) {
                                                                      var err = {
                                                                        keyword:
                                                                          "type",
                                                                        dataPath:
                                                                          (dataPath ||
                                                                            "") +
                                                                          ".natural_width",
                                                                        schemaPath:
                                                                          "#/properties/natural_width/anyOf/1/type",
                                                                        params: {
                                                                          type:
                                                                            "number"
                                                                        },
                                                                        message:
                                                                          "should be number"
                                                                      };
                                                                      if (
                                                                        vErrors ===
                                                                        null
                                                                      )
                                                                        vErrors = [
                                                                          err
                                                                        ];
                                                                      else
                                                                        vErrors.push(
                                                                          err
                                                                        );
                                                                      errors++;
                                                                    }
                                                                    var valid2 =
                                                                      errors ===
                                                                      errs_2;
                                                                    valid1 =
                                                                      valid1 ||
                                                                      valid2;
                                                                  }
                                                                  if (!valid1) {
                                                                    var err = {
                                                                      keyword:
                                                                        "anyOf",
                                                                      dataPath:
                                                                        (dataPath ||
                                                                          "") +
                                                                        ".natural_width",
                                                                      schemaPath:
                                                                        "#/properties/natural_width/anyOf",
                                                                      params: {},
                                                                      message:
                                                                        "should match some schema in anyOf"
                                                                    };
                                                                    if (
                                                                      vErrors ===
                                                                      null
                                                                    )
                                                                      vErrors = [
                                                                        err
                                                                      ];
                                                                    else
                                                                      vErrors.push(
                                                                        err
                                                                      );
                                                                    errors++;
                                                                    validate.errors = vErrors;
                                                                    return false;
                                                                  } else {
                                                                    errors = errs__1;
                                                                    if (
                                                                      vErrors !==
                                                                      null
                                                                    ) {
                                                                      if (
                                                                        errs__1
                                                                      )
                                                                        vErrors.length = errs__1;
                                                                      else
                                                                        vErrors = null;
                                                                    }
                                                                  }
                                                                  var valid1 =
                                                                    errors ===
                                                                    errs_1;
                                                                }
                                                                if (valid1) {
                                                                  var data1 =
                                                                    data.natural_height;
                                                                  if (
                                                                    data1 ===
                                                                    undefined
                                                                  ) {
                                                                    valid1 = true;
                                                                  } else {
                                                                    var errs_1 = errors;
                                                                    var errs__1 = errors;
                                                                    var valid1 = false;
                                                                    var errs_2 = errors;
                                                                    if (
                                                                      typeof data1 !==
                                                                      "string"
                                                                    ) {
                                                                      var err = {
                                                                        keyword:
                                                                          "type",
                                                                        dataPath:
                                                                          (dataPath ||
                                                                            "") +
                                                                          ".natural_height",
                                                                        schemaPath:
                                                                          "#/properties/natural_height/anyOf/0/type",
                                                                        params: {
                                                                          type:
                                                                            "string"
                                                                        },
                                                                        message:
                                                                          "should be string"
                                                                      };
                                                                      if (
                                                                        vErrors ===
                                                                        null
                                                                      )
                                                                        vErrors = [
                                                                          err
                                                                        ];
                                                                      else
                                                                        vErrors.push(
                                                                          err
                                                                        );
                                                                      errors++;
                                                                    }
                                                                    var valid2 =
                                                                      errors ===
                                                                      errs_2;
                                                                    valid1 =
                                                                      valid1 ||
                                                                      valid2;
                                                                    if (
                                                                      !valid1
                                                                    ) {
                                                                      var errs_2 = errors;
                                                                      if (
                                                                        typeof data1 !==
                                                                        "number"
                                                                      ) {
                                                                        var err = {
                                                                          keyword:
                                                                            "type",
                                                                          dataPath:
                                                                            (dataPath ||
                                                                              "") +
                                                                            ".natural_height",
                                                                          schemaPath:
                                                                            "#/properties/natural_height/anyOf/1/type",
                                                                          params: {
                                                                            type:
                                                                              "number"
                                                                          },
                                                                          message:
                                                                            "should be number"
                                                                        };
                                                                        if (
                                                                          vErrors ===
                                                                          null
                                                                        )
                                                                          vErrors = [
                                                                            err
                                                                          ];
                                                                        else
                                                                          vErrors.push(
                                                                            err
                                                                          );
                                                                        errors++;
                                                                      }
                                                                      var valid2 =
                                                                        errors ===
                                                                        errs_2;
                                                                      valid1 =
                                                                        valid1 ||
                                                                        valid2;
                                                                    }
                                                                    if (
                                                                      !valid1
                                                                    ) {
                                                                      var err = {
                                                                        keyword:
                                                                          "anyOf",
                                                                        dataPath:
                                                                          (dataPath ||
                                                                            "") +
                                                                          ".natural_height",
                                                                        schemaPath:
                                                                          "#/properties/natural_height/anyOf",
                                                                        params: {},
                                                                        message:
                                                                          "should match some schema in anyOf"
                                                                      };
                                                                      if (
                                                                        vErrors ===
                                                                        null
                                                                      )
                                                                        vErrors = [
                                                                          err
                                                                        ];
                                                                      else
                                                                        vErrors.push(
                                                                          err
                                                                        );
                                                                      errors++;
                                                                      validate.errors = vErrors;
                                                                      return false;
                                                                    } else {
                                                                      errors = errs__1;
                                                                      if (
                                                                        vErrors !==
                                                                        null
                                                                      ) {
                                                                        if (
                                                                          errs__1
                                                                        )
                                                                          vErrors.length = errs__1;
                                                                        else
                                                                          vErrors = null;
                                                                      }
                                                                    }
                                                                    var valid1 =
                                                                      errors ===
                                                                      errs_1;
                                                                  }
                                                                  if (valid1) {
                                                                    var data1 =
                                                                      data.max_width;
                                                                    if (
                                                                      data1 ===
                                                                      undefined
                                                                    ) {
                                                                      valid1 = true;
                                                                    } else {
                                                                      var errs_1 = errors;
                                                                      var errs__1 = errors;
                                                                      var valid1 = false;
                                                                      var errs_2 = errors;
                                                                      if (
                                                                        typeof data1 !==
                                                                        "string"
                                                                      ) {
                                                                        var err = {
                                                                          keyword:
                                                                            "type",
                                                                          dataPath:
                                                                            (dataPath ||
                                                                              "") +
                                                                            ".max_width",
                                                                          schemaPath:
                                                                            "#/properties/max_width/anyOf/0/type",
                                                                          params: {
                                                                            type:
                                                                              "string"
                                                                          },
                                                                          message:
                                                                            "should be string"
                                                                        };
                                                                        if (
                                                                          vErrors ===
                                                                          null
                                                                        )
                                                                          vErrors = [
                                                                            err
                                                                          ];
                                                                        else
                                                                          vErrors.push(
                                                                            err
                                                                          );
                                                                        errors++;
                                                                      }
                                                                      var valid2 =
                                                                        errors ===
                                                                        errs_2;
                                                                      valid1 =
                                                                        valid1 ||
                                                                        valid2;
                                                                      if (
                                                                        !valid1
                                                                      ) {
                                                                        var errs_2 = errors;
                                                                        if (
                                                                          typeof data1 !==
                                                                          "number"
                                                                        ) {
                                                                          var err = {
                                                                            keyword:
                                                                              "type",
                                                                            dataPath:
                                                                              (dataPath ||
                                                                                "") +
                                                                              ".max_width",
                                                                            schemaPath:
                                                                              "#/properties/max_width/anyOf/1/type",
                                                                            params: {
                                                                              type:
                                                                                "number"
                                                                            },
                                                                            message:
                                                                              "should be number"
                                                                          };
                                                                          if (
                                                                            vErrors ===
                                                                            null
                                                                          )
                                                                            vErrors = [
                                                                              err
                                                                            ];
                                                                          else
                                                                            vErrors.push(
                                                                              err
                                                                            );
                                                                          errors++;
                                                                        }
                                                                        var valid2 =
                                                                          errors ===
                                                                          errs_2;
                                                                        valid1 =
                                                                          valid1 ||
                                                                          valid2;
                                                                      }
                                                                      if (
                                                                        !valid1
                                                                      ) {
                                                                        var err = {
                                                                          keyword:
                                                                            "anyOf",
                                                                          dataPath:
                                                                            (dataPath ||
                                                                              "") +
                                                                            ".max_width",
                                                                          schemaPath:
                                                                            "#/properties/max_width/anyOf",
                                                                          params: {},
                                                                          message:
                                                                            "should match some schema in anyOf"
                                                                        };
                                                                        if (
                                                                          vErrors ===
                                                                          null
                                                                        )
                                                                          vErrors = [
                                                                            err
                                                                          ];
                                                                        else
                                                                          vErrors.push(
                                                                            err
                                                                          );
                                                                        errors++;
                                                                        validate.errors = vErrors;
                                                                        return false;
                                                                      } else {
                                                                        errors = errs__1;
                                                                        if (
                                                                          vErrors !==
                                                                          null
                                                                        ) {
                                                                          if (
                                                                            errs__1
                                                                          )
                                                                            vErrors.length = errs__1;
                                                                          else
                                                                            vErrors = null;
                                                                        }
                                                                      }
                                                                      var valid1 =
                                                                        errors ===
                                                                        errs_1;
                                                                    }
                                                                    if (
                                                                      valid1
                                                                    ) {
                                                                      if (
                                                                        data.with_text_pad ===
                                                                        undefined
                                                                      ) {
                                                                        valid1 = true;
                                                                      } else {
                                                                        var errs_1 = errors;
                                                                        if (
                                                                          typeof data.with_text_pad !==
                                                                          "boolean"
                                                                        ) {
                                                                          validate.errors = [
                                                                            {
                                                                              keyword:
                                                                                "type",
                                                                              dataPath:
                                                                                (dataPath ||
                                                                                  "") +
                                                                                ".with_text_pad",
                                                                              schemaPath:
                                                                                "#/properties/with_text_pad/type",
                                                                              params: {
                                                                                type:
                                                                                  "boolean"
                                                                              },
                                                                              message:
                                                                                "should be boolean"
                                                                            }
                                                                          ];
                                                                          return false;
                                                                        }
                                                                        var valid1 =
                                                                          errors ===
                                                                          errs_1;
                                                                      }
                                                                      if (
                                                                        valid1
                                                                      ) {
                                                                        var data1 =
                                                                          data.text_align;
                                                                        if (
                                                                          data1 ===
                                                                          undefined
                                                                        ) {
                                                                          valid1 = true;
                                                                        } else {
                                                                          var errs_1 = errors;
                                                                          if (
                                                                            typeof data1 !==
                                                                            "string"
                                                                          ) {
                                                                            validate.errors = [
                                                                              {
                                                                                keyword:
                                                                                  "type",
                                                                                dataPath:
                                                                                  (dataPath ||
                                                                                    "") +
                                                                                  ".text_align",
                                                                                schemaPath:
                                                                                  "#/properties/text_align/type",
                                                                                params: {
                                                                                  type:
                                                                                    "string"
                                                                                },
                                                                                message:
                                                                                  "should be string"
                                                                              }
                                                                            ];
                                                                            return false;
                                                                          }
                                                                          var schema1 =
                                                                            validate
                                                                              .schema
                                                                              .properties
                                                                              .text_align
                                                                              .enum;
                                                                          var valid1;
                                                                          valid1 = false;
                                                                          for (
                                                                            var i1 = 0;
                                                                            i1 <
                                                                            schema1.length;
                                                                            i1++
                                                                          )
                                                                            if (
                                                                              equal(
                                                                                data1,
                                                                                schema1[
                                                                                  i1
                                                                                ]
                                                                              )
                                                                            ) {
                                                                              valid1 = true;
                                                                              break;
                                                                            }
                                                                          if (
                                                                            !valid1
                                                                          ) {
                                                                            validate.errors = [
                                                                              {
                                                                                keyword:
                                                                                  "enum",
                                                                                dataPath:
                                                                                  (dataPath ||
                                                                                    "") +
                                                                                  ".text_align",
                                                                                schemaPath:
                                                                                  "#/properties/text_align/enum",
                                                                                params: {
                                                                                  allowedValues: schema1
                                                                                },
                                                                                message:
                                                                                  "should be equal to one of the allowed values"
                                                                              }
                                                                            ];
                                                                            return false;
                                                                          }
                                                                          var valid1 =
                                                                            errors ===
                                                                            errs_1;
                                                                        }
                                                                        if (
                                                                          valid1
                                                                        ) {
                                                                          if (
                                                                            data.src ===
                                                                            undefined
                                                                          ) {
                                                                            valid1 = true;
                                                                          } else {
                                                                            var errs_1 = errors;
                                                                            if (
                                                                              typeof data.src !==
                                                                              "string"
                                                                            ) {
                                                                              validate.errors = [
                                                                                {
                                                                                  keyword:
                                                                                    "type",
                                                                                  dataPath:
                                                                                    (dataPath ||
                                                                                      "") +
                                                                                    ".src",
                                                                                  schemaPath:
                                                                                    "#/properties/src/type",
                                                                                  params: {
                                                                                    type:
                                                                                      "string"
                                                                                  },
                                                                                  message:
                                                                                    "should be string"
                                                                                }
                                                                              ];
                                                                              return false;
                                                                            }
                                                                            var valid1 =
                                                                              errors ===
                                                                              errs_1;
                                                                          }
                                                                          if (
                                                                            valid1
                                                                          ) {
                                                                            if (
                                                                              data.href ===
                                                                              undefined
                                                                            ) {
                                                                              valid1 = true;
                                                                            } else {
                                                                              var errs_1 = errors;
                                                                              if (
                                                                                typeof data.href !==
                                                                                "string"
                                                                              ) {
                                                                                validate.errors = [
                                                                                  {
                                                                                    keyword:
                                                                                      "type",
                                                                                    dataPath:
                                                                                      (dataPath ||
                                                                                        "") +
                                                                                      ".href",
                                                                                    schemaPath:
                                                                                      "#/properties/href/type",
                                                                                    params: {
                                                                                      type:
                                                                                        "string"
                                                                                    },
                                                                                    message:
                                                                                      "should be string"
                                                                                  }
                                                                                ];
                                                                                return false;
                                                                              }
                                                                              var valid1 =
                                                                                errors ===
                                                                                errs_1;
                                                                            }
                                                                            if (
                                                                              valid1
                                                                            ) {
                                                                              var data1 =
                                                                                data.dimension;
                                                                              if (
                                                                                data1 ===
                                                                                undefined
                                                                              ) {
                                                                                valid1 = true;
                                                                              } else {
                                                                                var errs_1 = errors;
                                                                                if (
                                                                                  Array.isArray(
                                                                                    data1
                                                                                  )
                                                                                ) {
                                                                                  var errs__1 = errors;
                                                                                  var valid1;
                                                                                  for (
                                                                                    var i1 = 0;
                                                                                    i1 <
                                                                                    data1.length;
                                                                                    i1++
                                                                                  ) {
                                                                                    var data2 =
                                                                                      data1[
                                                                                        i1
                                                                                      ];
                                                                                    var errs_2 = errors;
                                                                                    var errs__2 = errors;
                                                                                    var valid2 = false;
                                                                                    var errs_3 = errors;
                                                                                    if (
                                                                                      typeof data2 !==
                                                                                      "string"
                                                                                    ) {
                                                                                      var err = {
                                                                                        keyword:
                                                                                          "type",
                                                                                        dataPath:
                                                                                          (dataPath ||
                                                                                            "") +
                                                                                          ".dimension[" +
                                                                                          i1 +
                                                                                          "]",
                                                                                        schemaPath:
                                                                                          "#/properties/dimension/items/anyOf/0/type",
                                                                                        params: {
                                                                                          type:
                                                                                            "string"
                                                                                        },
                                                                                        message:
                                                                                          "should be string"
                                                                                      };
                                                                                      if (
                                                                                        vErrors ===
                                                                                        null
                                                                                      )
                                                                                        vErrors = [
                                                                                          err
                                                                                        ];
                                                                                      else
                                                                                        vErrors.push(
                                                                                          err
                                                                                        );
                                                                                      errors++;
                                                                                    }
                                                                                    var valid3 =
                                                                                      errors ===
                                                                                      errs_3;
                                                                                    valid2 =
                                                                                      valid2 ||
                                                                                      valid3;
                                                                                    if (
                                                                                      !valid2
                                                                                    ) {
                                                                                      var errs_3 = errors;
                                                                                      if (
                                                                                        typeof data2 !==
                                                                                        "number"
                                                                                      ) {
                                                                                        var err = {
                                                                                          keyword:
                                                                                            "type",
                                                                                          dataPath:
                                                                                            (dataPath ||
                                                                                              "") +
                                                                                            ".dimension[" +
                                                                                            i1 +
                                                                                            "]",
                                                                                          schemaPath:
                                                                                            "#/properties/dimension/items/anyOf/1/type",
                                                                                          params: {
                                                                                            type:
                                                                                              "number"
                                                                                          },
                                                                                          message:
                                                                                            "should be number"
                                                                                        };
                                                                                        if (
                                                                                          vErrors ===
                                                                                          null
                                                                                        )
                                                                                          vErrors = [
                                                                                            err
                                                                                          ];
                                                                                        else
                                                                                          vErrors.push(
                                                                                            err
                                                                                          );
                                                                                        errors++;
                                                                                      }
                                                                                      var valid3 =
                                                                                        errors ===
                                                                                        errs_3;
                                                                                      valid2 =
                                                                                        valid2 ||
                                                                                        valid3;
                                                                                      if (
                                                                                        !valid2
                                                                                      ) {
                                                                                        var errs_3 = errors;
                                                                                        if (
                                                                                          data2 !==
                                                                                          null
                                                                                        ) {
                                                                                          var err = {
                                                                                            keyword:
                                                                                              "type",
                                                                                            dataPath:
                                                                                              (dataPath ||
                                                                                                "") +
                                                                                              ".dimension[" +
                                                                                              i1 +
                                                                                              "]",
                                                                                            schemaPath:
                                                                                              "#/properties/dimension/items/anyOf/2/type",
                                                                                            params: {
                                                                                              type:
                                                                                                "null"
                                                                                            },
                                                                                            message:
                                                                                              "should be null"
                                                                                          };
                                                                                          if (
                                                                                            vErrors ===
                                                                                            null
                                                                                          )
                                                                                            vErrors = [
                                                                                              err
                                                                                            ];
                                                                                          else
                                                                                            vErrors.push(
                                                                                              err
                                                                                            );
                                                                                          errors++;
                                                                                        }
                                                                                        var valid3 =
                                                                                          errors ===
                                                                                          errs_3;
                                                                                        valid2 =
                                                                                          valid2 ||
                                                                                          valid3;
                                                                                      }
                                                                                    }
                                                                                    if (
                                                                                      !valid2
                                                                                    ) {
                                                                                      var err = {
                                                                                        keyword:
                                                                                          "anyOf",
                                                                                        dataPath:
                                                                                          (dataPath ||
                                                                                            "") +
                                                                                          ".dimension[" +
                                                                                          i1 +
                                                                                          "]",
                                                                                        schemaPath:
                                                                                          "#/properties/dimension/items/anyOf",
                                                                                        params: {},
                                                                                        message:
                                                                                          "should match some schema in anyOf"
                                                                                      };
                                                                                      if (
                                                                                        vErrors ===
                                                                                        null
                                                                                      )
                                                                                        vErrors = [
                                                                                          err
                                                                                        ];
                                                                                      else
                                                                                        vErrors.push(
                                                                                          err
                                                                                        );
                                                                                      errors++;
                                                                                      validate.errors = vErrors;
                                                                                      return false;
                                                                                    } else {
                                                                                      errors = errs__2;
                                                                                      if (
                                                                                        vErrors !==
                                                                                        null
                                                                                      ) {
                                                                                        if (
                                                                                          errs__2
                                                                                        )
                                                                                          vErrors.length = errs__2;
                                                                                        else
                                                                                          vErrors = null;
                                                                                      }
                                                                                    }
                                                                                    var valid2 =
                                                                                      errors ===
                                                                                      errs_2;
                                                                                    if (
                                                                                      !valid2
                                                                                    )
                                                                                      break;
                                                                                  }
                                                                                } else {
                                                                                  validate.errors = [
                                                                                    {
                                                                                      keyword:
                                                                                        "type",
                                                                                      dataPath:
                                                                                        (dataPath ||
                                                                                          "") +
                                                                                        ".dimension",
                                                                                      schemaPath:
                                                                                        "#/properties/dimension/type",
                                                                                      params: {
                                                                                        type:
                                                                                          "array"
                                                                                      },
                                                                                      message:
                                                                                        "should be array"
                                                                                    }
                                                                                  ];
                                                                                  return false;
                                                                                }
                                                                                var valid1 =
                                                                                  errors ===
                                                                                  errs_1;
                                                                              }
                                                                              if (
                                                                                valid1
                                                                              ) {
                                                                                if (
                                                                                  data.socials ===
                                                                                  undefined
                                                                                ) {
                                                                                  valid1 = true;
                                                                                } else {
                                                                                  var errs_1 = errors;
                                                                                  if (
                                                                                    Array.isArray(
                                                                                      data.socials
                                                                                    )
                                                                                  ) {
                                                                                    var errs__1 = errors;
                                                                                    var valid1;
                                                                                  } else {
                                                                                    validate.errors = [
                                                                                      {
                                                                                        keyword:
                                                                                          "type",
                                                                                        dataPath:
                                                                                          (dataPath ||
                                                                                            "") +
                                                                                          ".socials",
                                                                                        schemaPath:
                                                                                          "#/properties/socials/type",
                                                                                        params: {
                                                                                          type:
                                                                                            "array"
                                                                                        },
                                                                                        message:
                                                                                          "should be array"
                                                                                      }
                                                                                    ];
                                                                                    return false;
                                                                                  }
                                                                                  var valid1 =
                                                                                    errors ===
                                                                                    errs_1;
                                                                                }
                                                                                if (
                                                                                  valid1
                                                                                ) {
                                                                                  var data1 =
                                                                                    data.rows;
                                                                                  if (
                                                                                    data1 ===
                                                                                    undefined
                                                                                  ) {
                                                                                    valid1 = true;
                                                                                  } else {
                                                                                    var errs_1 = errors;
                                                                                    var errs__1 = errors;
                                                                                    var valid1 = false;
                                                                                    var errs_2 = errors;
                                                                                    if (
                                                                                      Array.isArray(
                                                                                        data1
                                                                                      )
                                                                                    ) {
                                                                                      var errs__2 = errors;
                                                                                      var valid2;
                                                                                      for (
                                                                                        var i2 = 0;
                                                                                        i2 <
                                                                                        data1.length;
                                                                                        i2++
                                                                                      ) {
                                                                                        var errs_3 = errors;
                                                                                        if (
                                                                                          !refVal4(
                                                                                            data1[
                                                                                              i2
                                                                                            ],
                                                                                            (dataPath ||
                                                                                              "") +
                                                                                              ".rows[" +
                                                                                              i2 +
                                                                                              "]",
                                                                                            data1,
                                                                                            i2,
                                                                                            rootData
                                                                                          )
                                                                                        ) {
                                                                                          if (
                                                                                            vErrors ===
                                                                                            null
                                                                                          )
                                                                                            vErrors =
                                                                                              refVal4.errors;
                                                                                          else
                                                                                            vErrors = vErrors.concat(
                                                                                              refVal4.errors
                                                                                            );
                                                                                          errors =
                                                                                            vErrors.length;
                                                                                        }
                                                                                        var valid3 =
                                                                                          errors ===
                                                                                          errs_3;
                                                                                        if (
                                                                                          !valid3
                                                                                        )
                                                                                          break;
                                                                                      }
                                                                                    } else {
                                                                                      var err = {
                                                                                        keyword:
                                                                                          "type",
                                                                                        dataPath:
                                                                                          (dataPath ||
                                                                                            "") +
                                                                                          ".rows",
                                                                                        schemaPath:
                                                                                          "#/properties/rows/anyOf/0/type",
                                                                                        params: {
                                                                                          type:
                                                                                            "array"
                                                                                        },
                                                                                        message:
                                                                                          "should be array"
                                                                                      };
                                                                                      if (
                                                                                        vErrors ===
                                                                                        null
                                                                                      )
                                                                                        vErrors = [
                                                                                          err
                                                                                        ];
                                                                                      else
                                                                                        vErrors.push(
                                                                                          err
                                                                                        );
                                                                                      errors++;
                                                                                    }
                                                                                    var valid2 =
                                                                                      errors ===
                                                                                      errs_2;
                                                                                    valid1 =
                                                                                      valid1 ||
                                                                                      valid2;
                                                                                    if (
                                                                                      !valid1
                                                                                    ) {
                                                                                      var errs_2 = errors;
                                                                                      if (
                                                                                        data1 !==
                                                                                        null
                                                                                      ) {
                                                                                        var err = {
                                                                                          keyword:
                                                                                            "type",
                                                                                          dataPath:
                                                                                            (dataPath ||
                                                                                              "") +
                                                                                            ".rows",
                                                                                          schemaPath:
                                                                                            "#/properties/rows/anyOf/1/type",
                                                                                          params: {
                                                                                            type:
                                                                                              "null"
                                                                                          },
                                                                                          message:
                                                                                            "should be null"
                                                                                        };
                                                                                        if (
                                                                                          vErrors ===
                                                                                          null
                                                                                        )
                                                                                          vErrors = [
                                                                                            err
                                                                                          ];
                                                                                        else
                                                                                          vErrors.push(
                                                                                            err
                                                                                          );
                                                                                        errors++;
                                                                                      }
                                                                                      var valid2 =
                                                                                        errors ===
                                                                                        errs_2;
                                                                                      valid1 =
                                                                                        valid1 ||
                                                                                        valid2;
                                                                                    }
                                                                                    if (
                                                                                      !valid1
                                                                                    ) {
                                                                                      var err = {
                                                                                        keyword:
                                                                                          "anyOf",
                                                                                        dataPath:
                                                                                          (dataPath ||
                                                                                            "") +
                                                                                          ".rows",
                                                                                        schemaPath:
                                                                                          "#/properties/rows/anyOf",
                                                                                        params: {},
                                                                                        message:
                                                                                          "should match some schema in anyOf"
                                                                                      };
                                                                                      if (
                                                                                        vErrors ===
                                                                                        null
                                                                                      )
                                                                                        vErrors = [
                                                                                          err
                                                                                        ];
                                                                                      else
                                                                                        vErrors.push(
                                                                                          err
                                                                                        );
                                                                                      errors++;
                                                                                      validate.errors = vErrors;
                                                                                      return false;
                                                                                    } else {
                                                                                      errors = errs__1;
                                                                                      if (
                                                                                        vErrors !==
                                                                                        null
                                                                                      ) {
                                                                                        if (
                                                                                          errs__1
                                                                                        )
                                                                                          vErrors.length = errs__1;
                                                                                        else
                                                                                          vErrors = null;
                                                                                      }
                                                                                    }
                                                                                    var valid1 =
                                                                                      errors ===
                                                                                      errs_1;
                                                                                  }
                                                                                }
                                                                              }
                                                                            }
                                                                          }
                                                                        }
                                                                      }
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      } else {
        validate.errors = [
          {
            keyword: "type",
            dataPath: (dataPath || "") + "",
            schemaPath: "#/type",
            params: {
              type: "object"
            },
            message: "should be object"
          }
        ];
        return false;
      }
      if (errors === 0) {
        var errs__0 = errors,
          prevValid0 = false,
          valid0 = false,
          passingSchemas0 = null;
        var errs_1 = errors;
        var errs_2 = errors;
        if (data && typeof data === "object" && !Array.isArray(data)) {
          var errs__2 = errors;
          var valid3 = true;
          var data1 = data.kind;
          if (data1 === undefined) {
            valid3 = true;
          } else {
            var errs_3 = errors;
            if (typeof data1 !== "string") {
              var err = {
                keyword: "type",
                dataPath: (dataPath || "") + ".kind",
                schemaPath: "#/definitions/block/properties/kind/type",
                params: {
                  type: "string"
                },
                message: "should be string"
              };
              if (vErrors === null) vErrors = [err];
              else vErrors.push(err);
              errors++;
            }
            var schema3 = refVal6.properties.kind.enum;
            var valid3;
            valid3 = false;
            for (var i3 = 0; i3 < schema3.length; i3++)
              if (equal(data1, schema3[i3])) {
                valid3 = true;
                break;
              }
            if (!valid3) {
              var err = {
                keyword: "enum",
                dataPath: (dataPath || "") + ".kind",
                schemaPath: "#/definitions/block/properties/kind/enum",
                params: {
                  allowedValues: schema3
                },
                message: "should be equal to one of the allowed values"
              };
              if (vErrors === null) vErrors = [err];
              else vErrors.push(err);
              errors++;
            }
            var valid3 = errors === errs_3;
          }
        }
        var valid2 = errors === errs_2;
        var valid1 = errors === errs_1;
        if (valid1) {
          valid0 = prevValid0 = true;
          passingSchemas0 = 0;
        }
        var errs_1 = errors;
        var errs_2 = errors;
        if (data && typeof data === "object" && !Array.isArray(data)) {
          var errs__2 = errors;
          var valid3 = true;
          var data1 = data.kind;
          if (data1 === undefined) {
            valid3 = true;
          } else {
            var errs_3 = errors;
            if (typeof data1 !== "string") {
              var err = {
                keyword: "type",
                dataPath: (dataPath || "") + ".kind",
                schemaPath: "#/definitions/table/properties/kind/type",
                params: {
                  type: "string"
                },
                message: "should be string"
              };
              if (vErrors === null) vErrors = [err];
              else vErrors.push(err);
              errors++;
            }
            var schema3 = refVal7.properties.kind.enum;
            var valid3;
            valid3 = false;
            for (var i3 = 0; i3 < schema3.length; i3++)
              if (equal(data1, schema3[i3])) {
                valid3 = true;
                break;
              }
            if (!valid3) {
              var err = {
                keyword: "enum",
                dataPath: (dataPath || "") + ".kind",
                schemaPath: "#/definitions/table/properties/kind/enum",
                params: {
                  allowedValues: schema3
                },
                message: "should be equal to one of the allowed values"
              };
              if (vErrors === null) vErrors = [err];
              else vErrors.push(err);
              errors++;
            }
            var valid3 = errors === errs_3;
          }
        }
        var valid2 = errors === errs_2;
        var valid1 = errors === errs_1;
        if (valid1 && prevValid0) {
          valid0 = false;
          passingSchemas0 = [passingSchemas0, 1];
        } else {
          if (valid1) {
            valid0 = prevValid0 = true;
            passingSchemas0 = 1;
          }
          var errs_1 = errors;
          var errs_2 = errors;
          if (data && typeof data === "object" && !Array.isArray(data)) {
            var errs__2 = errors;
            var valid3 = true;
            var data1 = data.kind;
            if (data1 === undefined) {
              valid3 = true;
            } else {
              var errs_3 = errors;
              if (typeof data1 !== "string") {
                var err = {
                  keyword: "type",
                  dataPath: (dataPath || "") + ".kind",
                  schemaPath: "#/definitions/image/properties/kind/type",
                  params: {
                    type: "string"
                  },
                  message: "should be string"
                };
                if (vErrors === null) vErrors = [err];
                else vErrors.push(err);
                errors++;
              }
              var schema3 = refVal8.properties.kind.enum;
              var valid3;
              valid3 = false;
              for (var i3 = 0; i3 < schema3.length; i3++)
                if (equal(data1, schema3[i3])) {
                  valid3 = true;
                  break;
                }
              if (!valid3) {
                var err = {
                  keyword: "enum",
                  dataPath: (dataPath || "") + ".kind",
                  schemaPath: "#/definitions/image/properties/kind/enum",
                  params: {
                    allowedValues: schema3
                  },
                  message: "should be equal to one of the allowed values"
                };
                if (vErrors === null) vErrors = [err];
                else vErrors.push(err);
                errors++;
              }
              var valid3 = errors === errs_3;
            }
          }
          var valid2 = errors === errs_2;
          var valid1 = errors === errs_1;
          if (valid1 && prevValid0) {
            valid0 = false;
            passingSchemas0 = [passingSchemas0, 2];
          } else {
            if (valid1) {
              valid0 = prevValid0 = true;
              passingSchemas0 = 2;
            }
            var errs_1 = errors;
            var errs_2 = errors;
            if (data && typeof data === "object" && !Array.isArray(data)) {
              var errs__2 = errors;
              var valid3 = true;
              var data1 = data.kind;
              if (data1 === undefined) {
                valid3 = true;
              } else {
                var errs_3 = errors;
                if (typeof data1 !== "string") {
                  var err = {
                    keyword: "type",
                    dataPath: (dataPath || "") + ".kind",
                    schemaPath: "#/definitions/spacer/properties/kind/type",
                    params: {
                      type: "string"
                    },
                    message: "should be string"
                  };
                  if (vErrors === null) vErrors = [err];
                  else vErrors.push(err);
                  errors++;
                }
                var schema3 = refVal9.properties.kind.enum;
                var valid3;
                valid3 = false;
                for (var i3 = 0; i3 < schema3.length; i3++)
                  if (equal(data1, schema3[i3])) {
                    valid3 = true;
                    break;
                  }
                if (!valid3) {
                  var err = {
                    keyword: "enum",
                    dataPath: (dataPath || "") + ".kind",
                    schemaPath: "#/definitions/spacer/properties/kind/enum",
                    params: {
                      allowedValues: schema3
                    },
                    message: "should be equal to one of the allowed values"
                  };
                  if (vErrors === null) vErrors = [err];
                  else vErrors.push(err);
                  errors++;
                }
                var valid3 = errors === errs_3;
              }
            }
            var valid2 = errors === errs_2;
            var valid1 = errors === errs_1;
            if (valid1 && prevValid0) {
              valid0 = false;
              passingSchemas0 = [passingSchemas0, 3];
            } else {
              if (valid1) {
                valid0 = prevValid0 = true;
                passingSchemas0 = 3;
              }
              var errs_1 = errors;
              var errs_2 = errors;
              if (data && typeof data === "object" && !Array.isArray(data)) {
                var errs__2 = errors;
                var valid3 = true;
                var data1 = data.kind;
                if (data1 === undefined) {
                  valid3 = true;
                } else {
                  var errs_3 = errors;
                  if (typeof data1 !== "string") {
                    var err = {
                      keyword: "type",
                      dataPath: (dataPath || "") + ".kind",
                      schemaPath: "#/definitions/social/properties/kind/type",
                      params: {
                        type: "string"
                      },
                      message: "should be string"
                    };
                    if (vErrors === null) vErrors = [err];
                    else vErrors.push(err);
                    errors++;
                  }
                  var schema3 = refVal10.properties.kind.enum;
                  var valid3;
                  valid3 = false;
                  for (var i3 = 0; i3 < schema3.length; i3++)
                    if (equal(data1, schema3[i3])) {
                      valid3 = true;
                      break;
                    }
                  if (!valid3) {
                    var err = {
                      keyword: "enum",
                      dataPath: (dataPath || "") + ".kind",
                      schemaPath: "#/definitions/social/properties/kind/enum",
                      params: {
                        allowedValues: schema3
                      },
                      message: "should be equal to one of the allowed values"
                    };
                    if (vErrors === null) vErrors = [err];
                    else vErrors.push(err);
                    errors++;
                  }
                  var valid3 = errors === errs_3;
                }
              }
              var valid2 = errors === errs_2;
              var valid1 = errors === errs_1;
              if (valid1 && prevValid0) {
                valid0 = false;
                passingSchemas0 = [passingSchemas0, 4];
              } else {
                if (valid1) {
                  valid0 = prevValid0 = true;
                  passingSchemas0 = 4;
                }
                var errs_1 = errors;
                var errs_2 = errors;
                if (data && typeof data === "object" && !Array.isArray(data)) {
                  var errs__2 = errors;
                  var valid3 = true;
                  var data1 = data.kind;
                  if (data1 === undefined) {
                    valid3 = true;
                  } else {
                    var errs_3 = errors;
                    if (typeof data1 !== "string") {
                      var err = {
                        keyword: "type",
                        dataPath: (dataPath || "") + ".kind",
                        schemaPath: "#/definitions/button/properties/kind/type",
                        params: {
                          type: "string"
                        },
                        message: "should be string"
                      };
                      if (vErrors === null) vErrors = [err];
                      else vErrors.push(err);
                      errors++;
                    }
                    var schema3 = refVal11.properties.kind.enum;
                    var valid3;
                    valid3 = false;
                    for (var i3 = 0; i3 < schema3.length; i3++)
                      if (equal(data1, schema3[i3])) {
                        valid3 = true;
                        break;
                      }
                    if (!valid3) {
                      var err = {
                        keyword: "enum",
                        dataPath: (dataPath || "") + ".kind",
                        schemaPath: "#/definitions/button/properties/kind/enum",
                        params: {
                          allowedValues: schema3
                        },
                        message: "should be equal to one of the allowed values"
                      };
                      if (vErrors === null) vErrors = [err];
                      else vErrors.push(err);
                      errors++;
                    }
                    var valid3 = errors === errs_3;
                  }
                }
                var valid2 = errors === errs_2;
                var valid1 = errors === errs_1;
                if (valid1 && prevValid0) {
                  valid0 = false;
                  passingSchemas0 = [passingSchemas0, 5];
                } else {
                  if (valid1) {
                    valid0 = prevValid0 = true;
                    passingSchemas0 = 5;
                  }
                  var errs_1 = errors;
                  var errs_2 = errors;
                  if (
                    data &&
                    typeof data === "object" &&
                    !Array.isArray(data)
                  ) {
                    var errs__2 = errors;
                    var valid3 = true;
                    var data1 = data.kind;
                    if (data1 === undefined) {
                      valid3 = true;
                    } else {
                      var errs_3 = errors;
                      if (typeof data1 !== "string") {
                        var err = {
                          keyword: "type",
                          dataPath: (dataPath || "") + ".kind",
                          schemaPath:
                            "#/definitions/divider/properties/kind/type",
                          params: {
                            type: "string"
                          },
                          message: "should be string"
                        };
                        if (vErrors === null) vErrors = [err];
                        else vErrors.push(err);
                        errors++;
                      }
                      var schema3 = refVal12.properties.kind.enum;
                      var valid3;
                      valid3 = false;
                      for (var i3 = 0; i3 < schema3.length; i3++)
                        if (equal(data1, schema3[i3])) {
                          valid3 = true;
                          break;
                        }
                      if (!valid3) {
                        var err = {
                          keyword: "enum",
                          dataPath: (dataPath || "") + ".kind",
                          schemaPath:
                            "#/definitions/divider/properties/kind/enum",
                          params: {
                            allowedValues: schema3
                          },
                          message:
                            "should be equal to one of the allowed values"
                        };
                        if (vErrors === null) vErrors = [err];
                        else vErrors.push(err);
                        errors++;
                      }
                      var valid3 = errors === errs_3;
                    }
                  }
                  var valid2 = errors === errs_2;
                  var valid1 = errors === errs_1;
                  if (valid1 && prevValid0) {
                    valid0 = false;
                    passingSchemas0 = [passingSchemas0, 6];
                  } else {
                    if (valid1) {
                      valid0 = prevValid0 = true;
                      passingSchemas0 = 6;
                    }
                    var errs_1 = errors;
                    var errs_2 = errors;
                    if (
                      data &&
                      typeof data === "object" &&
                      !Array.isArray(data)
                    ) {
                      var errs__2 = errors;
                      var valid3 = true;
                      var data1 = data.kind;
                      if (data1 === undefined) {
                        valid3 = true;
                      } else {
                        var errs_3 = errors;
                        if (typeof data1 !== "string") {
                          var err = {
                            keyword: "type",
                            dataPath: (dataPath || "") + ".kind",
                            schemaPath:
                              "#/definitions/organization/properties/kind/type",
                            params: {
                              type: "string"
                            },
                            message: "should be string"
                          };
                          if (vErrors === null) vErrors = [err];
                          else vErrors.push(err);
                          errors++;
                        }
                        var schema3 = refVal13.properties.kind.enum;
                        var valid3;
                        valid3 = false;
                        for (var i3 = 0; i3 < schema3.length; i3++)
                          if (equal(data1, schema3[i3])) {
                            valid3 = true;
                            break;
                          }
                        if (!valid3) {
                          var err = {
                            keyword: "enum",
                            dataPath: (dataPath || "") + ".kind",
                            schemaPath:
                              "#/definitions/organization/properties/kind/enum",
                            params: {
                              allowedValues: schema3
                            },
                            message:
                              "should be equal to one of the allowed values"
                          };
                          if (vErrors === null) vErrors = [err];
                          else vErrors.push(err);
                          errors++;
                        }
                        var valid3 = errors === errs_3;
                      }
                    }
                    var valid2 = errors === errs_2;
                    var valid1 = errors === errs_1;
                    if (valid1 && prevValid0) {
                      valid0 = false;
                      passingSchemas0 = [passingSchemas0, 7];
                    } else {
                      if (valid1) {
                        valid0 = prevValid0 = true;
                        passingSchemas0 = 7;
                      }
                      var errs_1 = errors;
                      var errs_2 = errors;
                      if (
                        data &&
                        typeof data === "object" &&
                        !Array.isArray(data)
                      ) {
                        var errs__2 = errors;
                        var valid3 = true;
                        var data1 = data.kind;
                        if (data1 === undefined) {
                          valid3 = true;
                        } else {
                          var errs_3 = errors;
                          if (typeof data1 !== "string") {
                            var err = {
                              keyword: "type",
                              dataPath: (dataPath || "") + ".kind",
                              schemaPath:
                                "#/definitions/unsubscrible/properties/kind/type",
                              params: {
                                type: "string"
                              },
                              message: "should be string"
                            };
                            if (vErrors === null) vErrors = [err];
                            else vErrors.push(err);
                            errors++;
                          }
                          var schema3 = refVal14.properties.kind.enum;
                          var valid3;
                          valid3 = false;
                          for (var i3 = 0; i3 < schema3.length; i3++)
                            if (equal(data1, schema3[i3])) {
                              valid3 = true;
                              break;
                            }
                          if (!valid3) {
                            var err = {
                              keyword: "enum",
                              dataPath: (dataPath || "") + ".kind",
                              schemaPath:
                                "#/definitions/unsubscrible/properties/kind/enum",
                              params: {
                                allowedValues: schema3
                              },
                              message:
                                "should be equal to one of the allowed values"
                            };
                            if (vErrors === null) vErrors = [err];
                            else vErrors.push(err);
                            errors++;
                          }
                          var valid3 = errors === errs_3;
                        }
                      }
                      var valid2 = errors === errs_2;
                      var valid1 = errors === errs_1;
                      if (valid1 && prevValid0) {
                        valid0 = false;
                        passingSchemas0 = [passingSchemas0, 8];
                      } else {
                        if (valid1) {
                          valid0 = prevValid0 = true;
                          passingSchemas0 = 8;
                        }
                        var errs_1 = errors;
                        var errs_2 = errors;
                        if (
                          data &&
                          typeof data === "object" &&
                          !Array.isArray(data)
                        ) {
                          var errs__2 = errors;
                          var valid3 = true;
                          var data1 = data.kind;
                          if (data1 === undefined) {
                            valid3 = true;
                          } else {
                            var errs_3 = errors;
                            if (typeof data1 !== "string") {
                              var err = {
                                keyword: "type",
                                dataPath: (dataPath || "") + ".kind",
                                schemaPath:
                                  "#/definitions/video/properties/kind/type",
                                params: {
                                  type: "string"
                                },
                                message: "should be string"
                              };
                              if (vErrors === null) vErrors = [err];
                              else vErrors.push(err);
                              errors++;
                            }
                            var schema3 = refVal15.properties.kind.enum;
                            var valid3;
                            valid3 = false;
                            for (var i3 = 0; i3 < schema3.length; i3++)
                              if (equal(data1, schema3[i3])) {
                                valid3 = true;
                                break;
                              }
                            if (!valid3) {
                              var err = {
                                keyword: "enum",
                                dataPath: (dataPath || "") + ".kind",
                                schemaPath:
                                  "#/definitions/video/properties/kind/enum",
                                params: {
                                  allowedValues: schema3
                                },
                                message:
                                  "should be equal to one of the allowed values"
                              };
                              if (vErrors === null) vErrors = [err];
                              else vErrors.push(err);
                              errors++;
                            }
                            var valid3 = errors === errs_3;
                          }
                        }
                        var valid2 = errors === errs_2;
                        var valid1 = errors === errs_1;
                        if (valid1 && prevValid0) {
                          valid0 = false;
                          passingSchemas0 = [passingSchemas0, 9];
                        } else {
                          if (valid1) {
                            valid0 = prevValid0 = true;
                            passingSchemas0 = 9;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        if (!valid0) {
          var err = {
            keyword: "oneOf",
            dataPath: (dataPath || "") + "",
            schemaPath: "#/oneOf",
            params: {
              passingSchemas: passingSchemas0
            },
            message: "should match exactly one schema in oneOf"
          };
          if (vErrors === null) vErrors = [err];
          else vErrors.push(err);
          errors++;
          validate.errors = vErrors;
          return false;
        } else {
          errors = errs__0;
          if (vErrors !== null) {
            if (errs__0) vErrors.length = errs__0;
            else vErrors = null;
          }
        }
      }
      validate.errors = vErrors;
      return errors === 0;
    };
  })();
  refVal3.schema = {
    type: "object",
    required: ["id", "kind"],
    properties: {
      alt: {
        type: "string"
      },
      font_family: {
        type: "string"
      },
      font_size: {
        type: "string"
      },
      css_background: {
        type: "string"
      },
      css_background_image: {
        type: "string"
      },
      css_background_position: {
        type: "string"
      },
      css_background_repeat: {
        type: "string"
      },
      css_class: {
        type: "string"
      },
      css_color: {
        type: "string"
      },
      css_link_color: {
        type: "string"
      },
      css_border: {
        type: "string"
      },
      css_size: {
        type: "string"
      },
      css_border_radius: {
        type: "string"
      },
      css_border_color: {
        type: "string"
      },
      css_padding_top: {
        type: "string"
      },
      css_padding_bottom: {
        type: "string"
      },
      css_padding_left: {
        type: "string"
      },
      css_padding_right: {
        type: "string"
      },
      css_padding_lock: {
        type: "boolean"
      },
      label: {
        type: "string"
      },
      id: {
        type: "string"
      },
      normal_size: {
        type: "boolean"
      },
      show_sm: {
        type: "boolean"
      },
      hide_sm: {
        type: "boolean"
      },
      contents: {
        type: "string"
      },
      size: {
        type: "string"
      },
      height: {
        type: "string"
      },
      natural_width: {
        anyOf: [
          {
            type: "string"
          },
          {
            type: "number"
          }
        ]
      },
      natural_height: {
        anyOf: [
          {
            type: "string"
          },
          {
            type: "number"
          }
        ]
      },
      max_width: {
        anyOf: [
          {
            type: "string"
          },
          {
            type: "number"
          }
        ]
      },
      with_text_pad: {
        type: "boolean"
      },
      text_align: {
        type: "string",
        enum: ["left", "center", "right", "justify"]
      },
      src: {
        type: "string"
      },
      href: {
        type: "string"
      },
      dimension: {
        type: "array",
        items: {
          anyOf: [
            {
              type: "string"
            },
            {
              type: "number"
            },
            {
              type: "null"
            }
          ]
        }
      },
      socials: {
        type: "array",
        items: {
          srv: {
            type: "string"
          },
          url: {
            type: "string"
          }
        }
      },
      rows: {
        anyOf: [
          {
            type: "array",
            items: {
              $ref: "#/definitions/row"
            }
          },
          {
            type: "null"
          }
        ]
      }
    },
    oneOf: [
      {
        $ref: "#/definitions/block"
      },
      {
        $ref: "#/definitions/table"
      },
      {
        $ref: "#/definitions/image"
      },
      {
        $ref: "#/definitions/spacer"
      },
      {
        $ref: "#/definitions/social"
      },
      {
        $ref: "#/definitions/button"
      },
      {
        $ref: "#/definitions/divider"
      },
      {
        $ref: "#/definitions/organization"
      },
      {
        $ref: "#/definitions/unsubscrible"
      },
      {
        $ref: "#/definitions/video"
      }
    ]
  };
  refVal3.errors = null;
  refVal[3] = refVal3;
  var refVal4 = (function () {
    return function validate(
      data,
      dataPath,
      parentData,
      parentDataProperty,
      rootData
    ) {
      "use strict";
      var vErrors = null;
      var errors = 0;
      if (rootData === undefined) rootData = data;
      if (data && typeof data === "object" && !Array.isArray(data)) {
        if (true) {
          var errs__0 = errors;
          var valid1 = true;
          var data1 = data.columns;
          if (data1 === undefined) {
            valid1 = false;
            validate.errors = [
              {
                keyword: "required",
                dataPath: (dataPath || "") + "",
                schemaPath: "#/required",
                params: {
                  missingProperty: "columns"
                },
                message: "should have required property 'columns'"
              }
            ];
            return false;
          } else {
            var errs_1 = errors;
            var errs__1 = errors;
            var valid1 = false;
            var errs_2 = errors;
            if (Array.isArray(data1)) {
              var errs__2 = errors;
              var valid2;
              for (var i2 = 0; i2 < data1.length; i2++) {
                var errs_3 = errors;
                if (
                  !refVal5(
                    data1[i2],
                    (dataPath || "") + ".columns[" + i2 + "]",
                    data1,
                    i2,
                    rootData
                  )
                ) {
                  if (vErrors === null) vErrors = refVal5.errors;
                  else vErrors = vErrors.concat(refVal5.errors);
                  errors = vErrors.length;
                }
                var valid3 = errors === errs_3;
                if (!valid3) break;
              }
            } else {
              var err = {
                keyword: "type",
                dataPath: (dataPath || "") + ".columns",
                schemaPath: "#/properties/columns/anyOf/0/type",
                params: {
                  type: "array"
                },
                message: "should be array"
              };
              if (vErrors === null) vErrors = [err];
              else vErrors.push(err);
              errors++;
            }
            var valid2 = errors === errs_2;
            valid1 = valid1 || valid2;
            if (!valid1) {
              var errs_2 = errors;
              if (data1 !== null) {
                var err = {
                  keyword: "type",
                  dataPath: (dataPath || "") + ".columns",
                  schemaPath: "#/properties/columns/anyOf/1/type",
                  params: {
                    type: "null"
                  },
                  message: "should be null"
                };
                if (vErrors === null) vErrors = [err];
                else vErrors.push(err);
                errors++;
              }
              var valid2 = errors === errs_2;
              valid1 = valid1 || valid2;
            }
            if (!valid1) {
              var err = {
                keyword: "anyOf",
                dataPath: (dataPath || "") + ".columns",
                schemaPath: "#/properties/columns/anyOf",
                params: {},
                message: "should match some schema in anyOf"
              };
              if (vErrors === null) vErrors = [err];
              else vErrors.push(err);
              errors++;
              validate.errors = vErrors;
              return false;
            } else {
              errors = errs__1;
              if (vErrors !== null) {
                if (errs__1) vErrors.length = errs__1;
                else vErrors = null;
              }
            }
            var valid1 = errors === errs_1;
          }
        }
      } else {
        validate.errors = [
          {
            keyword: "type",
            dataPath: (dataPath || "") + "",
            schemaPath: "#/type",
            params: {
              type: "object"
            },
            message: "should be object"
          }
        ];
        return false;
      }
      validate.errors = vErrors;
      return errors === 0;
    };
  })();
  refVal4.schema = {
    type: "object",
    properties: {
      columns: {
        anyOf: [
          {
            type: "array",
            items: {
              $ref: "#/definitions/column"
            }
          },
          {
            type: "null"
          }
        ]
      }
    },
    required: ["columns"]
  };
  refVal4.errors = null;
  refVal[4] = refVal4;
  var refVal5 = (function () {
    return function validate(
      data,
      dataPath,
      parentData,
      parentDataProperty,
      rootData
    ) {
      "use strict";
      var vErrors = null;
      var errors = 0;
      if (rootData === undefined) rootData = data;
      if (data && typeof data === "object" && !Array.isArray(data)) {
        if (true) {
          var errs__0 = errors;
          var valid1 = true;
          if (data.background === undefined) {
            valid1 = true;
          } else {
            var errs_1 = errors;
            if (typeof data.background !== "string") {
              validate.errors = [
                {
                  keyword: "type",
                  dataPath: (dataPath || "") + ".background",
                  schemaPath: "#/properties/background/type",
                  params: {
                    type: "string"
                  },
                  message: "should be string"
                }
              ];
              return false;
            }
            var valid1 = errors === errs_1;
          }
          if (valid1) {
            if (data.background_image === undefined) {
              valid1 = true;
            } else {
              var errs_1 = errors;
              if (typeof data.background_image !== "string") {
                validate.errors = [
                  {
                    keyword: "type",
                    dataPath: (dataPath || "") + ".background_image",
                    schemaPath: "#/properties/background_image/type",
                    params: {
                      type: "string"
                    },
                    message: "should be string"
                  }
                ];
                return false;
              }
              var valid1 = errors === errs_1;
            }
            if (valid1) {
              if (data.background_position === undefined) {
                valid1 = true;
              } else {
                var errs_1 = errors;
                if (typeof data.background_position !== "string") {
                  validate.errors = [
                    {
                      keyword: "type",
                      dataPath: (dataPath || "") + ".background_position",
                      schemaPath: "#/properties/background_position/type",
                      params: {
                        type: "string"
                      },
                      message: "should be string"
                    }
                  ];
                  return false;
                }
                var valid1 = errors === errs_1;
              }
              if (valid1) {
                if (data.background_repeat === undefined) {
                  valid1 = true;
                } else {
                  var errs_1 = errors;
                  if (typeof data.background_repeat !== "string") {
                    validate.errors = [
                      {
                        keyword: "type",
                        dataPath: (dataPath || "") + ".background_repeat",
                        schemaPath: "#/properties/background_repeat/type",
                        params: {
                          type: "string"
                        },
                        message: "should be string"
                      }
                    ];
                    return false;
                  }
                  var valid1 = errors === errs_1;
                }
                if (valid1) {
                  var data1 = data.items;
                  if (data1 === undefined) {
                    valid1 = false;
                    validate.errors = [
                      {
                        keyword: "required",
                        dataPath: (dataPath || "") + "",
                        schemaPath: "#/required",
                        params: {
                          missingProperty: "items"
                        },
                        message: "should have required property 'items'"
                      }
                    ];
                    return false;
                  } else {
                    var errs_1 = errors;
                    var errs__1 = errors;
                    var valid1 = false;
                    var errs_2 = errors;
                    if (Array.isArray(data1)) {
                      var errs__2 = errors;
                      var valid2;
                      for (var i2 = 0; i2 < data1.length; i2++) {
                        var errs_3 = errors;
                        if (
                          !refVal[3](
                            data1[i2],
                            (dataPath || "") + ".items[" + i2 + "]",
                            data1,
                            i2,
                            rootData
                          )
                        ) {
                          if (vErrors === null) vErrors = refVal[3].errors;
                          else vErrors = vErrors.concat(refVal[3].errors);
                          errors = vErrors.length;
                        }
                        var valid3 = errors === errs_3;
                        if (!valid3) break;
                      }
                    } else {
                      var err = {
                        keyword: "type",
                        dataPath: (dataPath || "") + ".items",
                        schemaPath: "#/properties/items/anyOf/0/type",
                        params: {
                          type: "array"
                        },
                        message: "should be array"
                      };
                      if (vErrors === null) vErrors = [err];
                      else vErrors.push(err);
                      errors++;
                    }
                    var valid2 = errors === errs_2;
                    valid1 = valid1 || valid2;
                    if (!valid1) {
                      var errs_2 = errors;
                      if (data1 !== null) {
                        var err = {
                          keyword: "type",
                          dataPath: (dataPath || "") + ".items",
                          schemaPath: "#/properties/items/anyOf/1/type",
                          params: {
                            type: "null"
                          },
                          message: "should be null"
                        };
                        if (vErrors === null) vErrors = [err];
                        else vErrors.push(err);
                        errors++;
                      }
                      var valid2 = errors === errs_2;
                      valid1 = valid1 || valid2;
                    }
                    if (!valid1) {
                      var err = {
                        keyword: "anyOf",
                        dataPath: (dataPath || "") + ".items",
                        schemaPath: "#/properties/items/anyOf",
                        params: {},
                        message: "should match some schema in anyOf"
                      };
                      if (vErrors === null) vErrors = [err];
                      else vErrors.push(err);
                      errors++;
                      validate.errors = vErrors;
                      return false;
                    } else {
                      errors = errs__1;
                      if (vErrors !== null) {
                        if (errs__1) vErrors.length = errs__1;
                        else vErrors = null;
                      }
                    }
                    var valid1 = errors === errs_1;
                  }
                }
              }
            }
          }
        }
      } else {
        validate.errors = [
          {
            keyword: "type",
            dataPath: (dataPath || "") + "",
            schemaPath: "#/type",
            params: {
              type: "object"
            },
            message: "should be object"
          }
        ];
        return false;
      }
      validate.errors = vErrors;
      return errors === 0;
    };
  })();
  refVal5.schema = {
    type: "object",
    properties: {
      background: {
        type: "string"
      },
      background_image: {
        type: "string"
      },
      background_position: {
        type: "string"
      },
      background_repeat: {
        type: "string"
      },
      items: {
        anyOf: [
          {
            type: "array",
            items: {
              $ref: "#/definitions/item"
            }
          },
          {
            type: "null"
          }
        ]
      }
    },
    required: ["items"]
  };
  refVal5.errors = null;
  refVal[5] = refVal5;
  var refVal6 = {
    properties: {
      kind: {
        type: "string",
        enum: ["block"]
      }
    }
  };
  refVal[6] = refVal6;
  var refVal7 = {
    properties: {
      kind: {
        type: "string",
        enum: ["table"]
      }
    }
  };
  refVal[7] = refVal7;
  var refVal8 = {
    properties: {
      kind: {
        type: "string",
        enum: ["image"]
      }
    }
  };
  refVal[8] = refVal8;
  var refVal9 = {
    properties: {
      kind: {
        type: "string",
        enum: ["spacer"]
      }
    }
  };
  refVal[9] = refVal9;
  var refVal10 = {
    properties: {
      kind: {
        type: "string",
        enum: ["social"]
      }
    }
  };
  refVal[10] = refVal10;
  var refVal11 = {
    properties: {
      kind: {
        type: "string",
        enum: ["button"]
      }
    }
  };
  refVal[11] = refVal11;
  var refVal12 = {
    properties: {
      kind: {
        type: "string",
        enum: ["divider"]
      }
    }
  };
  refVal[12] = refVal12;
  var refVal13 = {
    properties: {
      kind: {
        type: "string",
        enum: ["organization"]
      }
    }
  };
  refVal[13] = refVal13;
  var refVal14 = {
    properties: {
      kind: {
        type: "string",
        enum: ["unsubscrible"]
      }
    }
  };
  refVal[14] = refVal14;
  var refVal15 = {
    properties: {
      kind: {
        type: "string",
        enum: ["video"]
      }
    }
  };
  refVal[15] = refVal15;
  return function validate(
    data,
    dataPath,
    parentData,
    parentDataProperty,
    rootData
  ) {
    "use strict";
    var vErrors = null;
    var errors = 0;
    if (rootData === undefined) rootData = data;
    var errs__0 = errors;
    var valid0 = false;
    var errs_1 = errors;
    if (Array.isArray(data)) {
      var errs__1 = errors;
      var valid1;
      for (var i1 = 0; i1 < data.length; i1++) {
        var errs_2 = errors;
        if (
          !refVal1(
            data[i1],
            (dataPath || "") + "[" + i1 + "]",
            data,
            i1,
            rootData
          )
        ) {
          if (vErrors === null) vErrors = refVal1.errors;
          else vErrors = vErrors.concat(refVal1.errors);
          errors = vErrors.length;
        }
        var valid2 = errors === errs_2;
        if (!valid2) break;
      }
    } else {
      var err = {
        keyword: "type",
        dataPath: (dataPath || "") + "",
        schemaPath: "#/anyOf/0/type",
        params: {
          type: "array"
        },
        message: "should be array"
      };
      if (vErrors === null) vErrors = [err];
      else vErrors.push(err);
      errors++;
    }
    var valid1 = errors === errs_1;
    valid0 = valid0 || valid1;
    if (!valid0) {
      var errs_1 = errors;
      if (data !== null) {
        var err = {
          keyword: "type",
          dataPath: (dataPath || "") + "",
          schemaPath: "#/anyOf/1/type",
          params: {
            type: "null"
          },
          message: "should be null"
        };
        if (vErrors === null) vErrors = [err];
        else vErrors.push(err);
        errors++;
      }
      var valid1 = errors === errs_1;
      valid0 = valid0 || valid1;
    }
    if (!valid0) {
      var err = {
        keyword: "anyOf",
        dataPath: (dataPath || "") + "",
        schemaPath: "#/anyOf",
        params: {},
        message: "should match some schema in anyOf"
      };
      if (vErrors === null) vErrors = [err];
      else vErrors.push(err);
      errors++;
      validate.errors = vErrors;
      return false;
    } else {
      errors = errs__0;
      if (vErrors !== null) {
        if (errs__0) vErrors.length = errs__0;
        else vErrors = null;
      }
    }
    validate.errors = vErrors;
    return errors === 0;
  };
})();
validate.schema = {
  $schema: "http://json-schema.org/draft-04/schema",
  anyOf: [
    {
      type: "array",
      items: {
        $ref: "#/definitions/section"
      }
    },
    {
      type: "null"
    }
  ],
  definitions: {
    block: {
      properties: {
        kind: {
          type: "string",
          enum: ["block"]
        }
      }
    },
    table: {
      properties: {
        kind: {
          type: "string",
          enum: ["table"]
        }
      }
    },
    image: {
      properties: {
        kind: {
          type: "string",
          enum: ["image"]
        }
      }
    },
    spacer: {
      properties: {
        kind: {
          type: "string",
          enum: ["spacer"]
        }
      }
    },
    social: {
      properties: {
        kind: {
          type: "string",
          enum: ["social"]
        }
      }
    },
    button: {
      properties: {
        kind: {
          type: "string",
          enum: ["button"]
        }
      }
    },
    divider: {
      properties: {
        kind: {
          type: "string",
          enum: ["divider"]
        }
      }
    },
    organization: {
      properties: {
        kind: {
          type: "string",
          enum: ["organization"]
        }
      }
    },
    unsubscrible: {
      properties: {
        kind: {
          type: "string",
          enum: ["unsubscrible"]
        }
      }
    },
    video: {
      properties: {
        kind: {
          type: "string",
          enum: ["video"]
        }
      }
    },
    item: {
      type: "object",
      required: ["id", "kind"],
      properties: {
        alt: {
          type: "string"
        },
        font_family: {
          type: "string"
        },
        font_size: {
          type: "string"
        },
        css_background: {
          type: "string"
        },
        css_background_image: {
          type: "string"
        },
        css_background_position: {
          type: "string"
        },
        css_background_repeat: {
          type: "string"
        },
        css_class: {
          type: "string"
        },
        css_color: {
          type: "string"
        },
        css_link_color: {
          type: "string"
        },
        css_border: {
          type: "string"
        },
        css_size: {
          type: "string"
        },
        css_border_radius: {
          type: "string"
        },
        css_border_color: {
          type: "string"
        },
        css_padding_top: {
          type: "string"
        },
        css_padding_bottom: {
          type: "string"
        },
        css_padding_left: {
          type: "string"
        },
        css_padding_right: {
          type: "string"
        },
        css_padding_lock: {
          type: "boolean"
        },
        label: {
          type: "string"
        },
        id: {
          type: "string"
        },
        normal_size: {
          type: "boolean"
        },
        show_sm: {
          type: "boolean"
        },
        hide_sm: {
          type: "boolean"
        },
        contents: {
          type: "string"
        },
        size: {
          type: "string"
        },
        height: {
          type: "string"
        },
        natural_width: {
          anyOf: [
            {
              type: "string"
            },
            {
              type: "number"
            }
          ]
        },
        natural_height: {
          anyOf: [
            {
              type: "string"
            },
            {
              type: "number"
            }
          ]
        },
        max_width: {
          anyOf: [
            {
              type: "string"
            },
            {
              type: "number"
            }
          ]
        },
        with_text_pad: {
          type: "boolean"
        },
        text_align: {
          type: "string",
          enum: ["left", "center", "right", "justify"]
        },
        src: {
          type: "string"
        },
        href: {
          type: "string"
        },
        dimension: {
          type: "array",
          items: {
            anyOf: [
              {
                type: "string"
              },
              {
                type: "number"
              },
              {
                type: "null"
              }
            ]
          }
        },
        socials: {
          type: "array",
          items: {
            srv: {
              type: "string"
            },
            url: {
              type: "string"
            }
          }
        },
        rows: {
          anyOf: [
            {
              type: "array",
              items: {
                $ref: "#/definitions/row"
              }
            },
            {
              type: "null"
            }
          ]
        }
      },
      oneOf: [
        {
          $ref: "#/definitions/block"
        },
        {
          $ref: "#/definitions/table"
        },
        {
          $ref: "#/definitions/image"
        },
        {
          $ref: "#/definitions/spacer"
        },
        {
          $ref: "#/definitions/social"
        },
        {
          $ref: "#/definitions/button"
        },
        {
          $ref: "#/definitions/divider"
        },
        {
          $ref: "#/definitions/organization"
        },
        {
          $ref: "#/definitions/unsubscrible"
        },
        {
          $ref: "#/definitions/video"
        }
      ]
    },
    content: {
      type: "object",
      properties: {
        column: {
          type: "string",
          enum: [
            "one",
            "two",
            "three",
            "four",
            "five",
            "six",
            "seven",
            "eight",
            "nine",
            "ten",
            "eleven",
            "twelve"
          ]
        },
        items: {
          anyOf: [
            {
              type: "array",
              items: {
                $ref: "#/definitions/item"
              }
            },
            {
              type: "null"
            }
          ]
        }
      },
      required: ["column", "items"]
    },
    section: {
      type: "object",
      properties: {
        background: {
          type: "string"
        },
        background_image: {
          type: "string"
        },
        background_position: {
          type: "string"
        },
        background_repeat: {
          type: "string"
        },
        full_width: {
          type: "boolean",
          default: false
        },
        contents: {
          anyOf: [
            {
              type: "array",
              items: {
                $ref: "#/definitions/content"
              }
            },
            {
              type: "null"
            }
          ]
        }
      },
      required: ["contents"]
    },
    row: {
      type: "object",
      properties: {
        columns: {
          anyOf: [
            {
              type: "array",
              items: {
                $ref: "#/definitions/column"
              }
            },
            {
              type: "null"
            }
          ]
        }
      },
      required: ["columns"]
    },
    column: {
      type: "object",
      properties: {
        background: {
          type: "string"
        },
        background_image: {
          type: "string"
        },
        background_position: {
          type: "string"
        },
        background_repeat: {
          type: "string"
        },
        items: {
          anyOf: [
            {
              type: "array",
              items: {
                $ref: "#/definitions/item"
              }
            },
            {
              type: "null"
            }
          ]
        }
      },
      required: ["items"]
    }
  }
};
validate.errors = null;
module.exports = validate;
